module.exports = __webpack_public_path__ + "58430326.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/desktop/routes/not-found/error.jpg
// module id = 3316
// module chunks = 38